import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule, Routes } from '@angular/router';
import { FileUploadComponent } from './card/new/file-upload/file-upload.component';
import { DashboardComponent } from './card/dashboard/dashboard.component'
import { SignUpComponent } from './sign-up/sign-up.component';
import { LoginComponent } from './login/login.component'
import { IntroComponent } from './intro/intro.component'
import { NotFoundComponent } from './error/not-found/not-found.component';
import { AuthGuard } from './auth.guard';
import { ListComponent } from './form/list/list.component'


const routes: Routes = [
  { path: 'intro', component: IntroComponent },
  { path: '', component: DashboardComponent },
  { path: 'new', component: FileUploadComponent },
  { path: 'signup', component: SignUpComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'login/:email', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'users', loadChildren: './users/users.module#UsersModule' },
  { path: 'formlist', component: ListComponent },
  { path: '**', component: NotFoundComponent }
  ];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: [],
  providers: [AuthGuard]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/app-routing.module.ts